export const API_URL = "https://source.empresasmaggi.com.br/api/v1"